import { number } from 'prop-types';
import React from 'react';

import CurrencyFormat from '../../generic/CurrencyFormat';
import { COLORS } from '../../utils/constants';

export default function DiffHighlighter({ diff }) {
  return (
    <span
      className={`text-nowrap font-weight-semi-bold text-${
        diff >= 0 ? COLORS.SUCCESS : COLORS.DANGER
      }`}
    >
      {diff >= 0 ? '+' : '-'}
      <CurrencyFormat value={diff} text allowNegative={false} />
    </span>
  );
}

DiffHighlighter.propTypes = {
  diff: number.isRequired,
};
